import { Version } from '@repo/toolkit/types'
import { PaginationRequest } from '@repo/ui/data-table'

import { TripBasic, TripSort } from '../../lib/types/models/trip/trip'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterTrips(
  id: number,
  query: PaginationRequest<null, Version, Version, TripSort> = {}
) {
  if (!query.sort) query.sort = { departure: { label: 'asc' } }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.centers.getCenterTrips.url, { id }), query))
    .get<TripBasic[]>()
}
